import ContactDatagrid from './components/Contacts/ContactDatagrid';
import ContactDetails from './components/Contacts/ContactDetails';

const routes = [

    {

        /** Listagem de Situações **/
        path: '/',
        component: ContactDatagrid,
        name: 'contact-datagrid',

    },

    {

        /** Listagem de Situações **/
        path: '/detalhes/',
        component: ContactDetails,
        name: 'contact-details',

    },

];

export default routes;